<template>
    <recipe-content-section
        class="recipe-content-section-module"
        :section-name="attributes.section_name"
        :back-button-link="backBtnLink"
        :instructions="instructions"
        :ingredients="ingredients"
        :where-to-buy-link="getLinkUri('where_to_buy_link')"
        :recipe-details="recipeDetails"
        :name="attributesData.name"
        :products="products"
        :make-me-veggie-url="getLinkUri('make_me_veggie_url')"
        :desktop-image="desktopImage"
        :mobile-image="mobileImage"
        :read-more="readMore"
    />
</template>

<script>
    import RecipeContentSection from '../../../organisms/RecipeContentSection/RecipeContentSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'recipe-content-section-module',

        components: { RecipeContentSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Get attributes data.
             *
             * @returns {object}
             */
            attributesData() {
                return this.attributes.recipe?.data?.attributes;
            },

            /**
             * Get back button link.
             *
             * @returns {string}
             */
            backBtnLink() {
                return this.attributes.back_button_link
                    ?.data
                    ?.attributes
                    ?.uri;
            },

            /**
             * Format instructions data.
             *
             * @returns {object}
             */
            instructions() {
                return {
                    title: this.attributesData?.instructions_title,
                    steps: this.attributesData?.steps,
                    subTitle: {
                        name: this.attributesData?.instruction_sub_title_text,
                        to: this.attributesData?.instruction_sub_title_link,
                    },
                };
            },

            /**
             * Format ingredients data.
             *
             * @returns {object}
             */
            ingredients() {
                return (this.attributesData?.ingredients || []).map((ingredient) => {
                    return {
                        name: ingredient.name,
                        buttonLink: ingredient.get_me_link,
                    };
                });
            },

            /**
             * Format recipeDetails data.
             *
             * @returns {object}
             */
            recipeDetails() {
                return {
                    serves: this.attributesData?.serves,
                    prepTime: this.attributesData?.prep_time,
                    cookTime: this.attributesData?.cook_time,
                };
            },

            /**
             * Format products data.
             *
             * @returns {object}
             */
            products() {
                return (this.attributesData?.grocery_products?.data || []).map((product) => {
                    return {
                        name: product.attributes?.name,
                        calories: product.attributes?.calories,
                        image: formatMediaObject.call(this, product.attributes?.website_thumbnail_image),
                        to: product.attributes?.page?.data?.attributes?.uri,
                    };
                });
            },

            /**
             * Format mobileImage.
             *
             * @returns {object}
             */
            mobileImage() {
                return formatMediaObject.call(this, this.attributesData?.mobile_image);
            },

            /**
             * Format desktopImage.
             *
             * @returns {object}
             */
            desktopImage() {
                return formatMediaObject.call(this, this.attributesData?.desktop_image);
            },

            /**
             * Return the read more content.
             *
             * @returns {object}
             */
            readMore() {
                return {
                    buttonText: this.attributes.read_more?.button_text,
                    content: this.attributes.read_more?.content,
                };
            },
        },

        methods: {
            /**
             * Get link attribute uri.
             *
             * @param {object} attribute
             *
             * @returns {string}
             */
            getLinkUri(attribute) {
                return this.attributesData
                    [attribute]
                    ?.data
                    ?.attributes
                    ?.uri;
            },
        },
    };
</script>
